/* eslint-disable n/no-callback-literal */
import { getEffectiveFirebaseIdToken } from '@/features/impersonation/effectiveFirebaseToken'
import { io, Socket } from 'socket.io-client'

const WS_URL = process.env.REACT_APP_WS_URL || ''

let _socket: Socket | null = null

export function getSocket(): Socket {
  if (!_socket) {
    _socket = io(WS_URL, {
      autoConnect: false,
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
      auth: async cb => {
        try {
          const token = await getEffectiveFirebaseIdToken(true)
          cb({ token })
        } catch {
          cb({ token: '' })
        }
      }
    })
  }
  return _socket
}

export function connectSocket(): void {
  getSocket().connect()
}

export function disconnectSocket(): void {
  if (_socket?.connected) {
    _socket.disconnect()
  }
}

export function setupSocketReconnectListeners(): () => void {
  const socket = getSocket()

  const reconnectIfNeeded = () => {
    if (!socket.connected) {
      socket.connect()
    }
  }

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      reconnectIfNeeded()
    }
  }

  window.addEventListener('online', reconnectIfNeeded)
  document.addEventListener('visibilitychange', handleVisibilityChange)

  return () => {
    window.removeEventListener('online', reconnectIfNeeded)
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  }
}
